import { CreateInvoiceRequestSchema } from '@vy/api-definition';
import { oz } from '@vy/utils';

export const NewInvoiceFormSchema = oz
  .object(CreateInvoiceRequestSchema.shape)
  .refine((data) => data.fixedProducts.length > 0 || (data.credits?.length ?? 0) > 0, {
    message: 'Add at least one fee or credit',
    path: ['productsValidation'],
  });

export type NewInvoiceForm = oz.infer<typeof NewInvoiceFormSchema>;
